// extracted by mini-css-extract-plugin
export default {"sectionElevatorDivider":"B9Pwd7dcB7pR72MA34yu","sectionElevator":"ARkAbvAS8Chde1Dzlr4S","narrow":"v9_WQcnHpfR62DUpAH9b"};